import { useState } from 'react'
import { useLoadScript } from '@react-google-maps/api'

import { Location, location } from '@ecm/data/Location'
import { runEff } from '@ecm/effect'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const google: any
const libraries: ('geometry' | 'places' | 'drawing' | 'localContext' | 'visualization')[] = [
  'geometry',
  'places',
]
const DEFAULT_CENTER = location({ lat: 28.9, lng: -97.6 })
const DEFAULT_ZOOM = 2
const DEFAULT_MAX_ZOOM = 17

const useMapReference = () => {
  const googleMapsApiKey = runEff(eff => eff.ask().googleMaps.apiKey)
  const { isLoaded } = useLoadScript({
    googleMapsApiKey,
    libraries,
  })

  const [center, setCenter] = useState<Location | google.maps.LatLng | undefined>(DEFAULT_CENTER)
  const [zoom, setZoom] = useState<number | undefined>(DEFAULT_ZOOM)

  const [mapReference, setMapReference] = useState<google.maps.Map | undefined>()

  const [clearBtnVisibility, setClearBtnVisibility] = useState(true)

  return {
    DEFAULT_CENTER,
    DEFAULT_MAX_ZOOM,
    center,
    clearBtnVisibility,
    isLoaded,
    mapReference,
    setCenter,
    setClearBtnVisibility,
    setMapReference,
    setZoom,
    zoom,
  }
}

export default useMapReference
